/**
 * External dependencies
 */
import { Component } from 'react'
import classnames from 'classnames'
import { range } from '~bookwormgb/util/range'

/**
 * Wordpress dependencies
 */
import {
	Fragment,
} from '@wordpress/element'

class ProductsDealsCarouselPlaceholder extends Component {

	render() {
		const {
			limit = 3,
			placeholder = 0,
			showImage = true,
			showProductFormat = true,
			showProductTitle = true,
			showProductAuthor = true,
			showProductPrice = true,
			showProductRating = true,
			showTimer = true,
			showTimerTitle = true,
			showProgressBar = true,
			design = 'style-v1',
			mdColumns = 2,
			lgColumns = 2,
			xlColumns = 2,
		} = this.props

		const output = (
			<div className={ classnames( [ `products-deal-carousel-placeholder bg-white row flex-nowrap overflow-hidden row-cols-md-${ mdColumns } row-cols-lg-${ lgColumns } row-cols-xl-${ xlColumns }` ], { 
				'border' : design === 'style-v1',
				'products' : ( design !== 'style-v3' && design !== 'style-v5' && design !== 'style-v6' ),
				'border-left border-right' : design === 'style-v3',
				'no-gutters' : design !== 'style-v4',
				'border border-width-2' : design === 'style-v5',
				'row-cols-1' : design === 'style-v6',
				} ) }
			>
				{ range( 1, ( placeholder > 0 ? placeholder : limit ) + 1 ).map( i => {
					return(
						<div className={ classnames( [ 'col' ], { 
								'product__card border-right' : ( design !== 'style-v3' && design !== 'style-v4' && design !== 'style-v5' && design !== 'style-v6' ),
								'border-right border-bottom border-top' : design === 'style-v3',
								'product__card' : design === 'style-v4' || design === 'style-v5',
								'product' : design !== 'style-v4',
							} ) } 
							key={ `product-${i}` }
						>
							<div className={ classnames( [ '' ], { 
									'p-md-6 p-4' : design === 'style-v1', 
									'px-4 px-md-6 px-xl-8d75' : design === 'style-v2',
									'media d-block d-md-flex' : design !== 'style-v3',
									'product__inner overflow-hidden p-3 p-md-4d875' : design === 'style-v3',
									'p-3 p-md-4d875 border rounded-md' : design === 'style-v4',
									'p-md-6 p-lg-10 p-4' : design === 'style-v5',
									'flex-column p-5 border border-width-2' : design === 'style-v6',
								} ) }
							>
								{ showImage &&
									<div className={ classnames( [ 'progress bg-light mx-auto' ], { 'mb-2' : design !== 'style-v5', 'mb-4' : design !== 'style-v5' } ) } style={ 
										design !== 'style-v4' ? design === 'style-v6' ? { width:'190px', height:'222px' } : { width:'200px', height:'327px' } : { width:'120px', height:'183px' } 
									}></div>
								}
								<div className={ classnames( [ 'media-body' ], { 
									'ml-md-5d25' : ( design !== 'style-v3' && design !== 'style-v4' && design !== 'style-v6' ), 'ml-4d875' : design === 'style-v4', 'w-100' : design === 'style-v6' 
								} ) }>
									{ showProductFormat &&
										<div className="badge badge-shadow w-50">
											<div className="progress bg-light"></div>
										</div>
									}
									{ showProductTitle &&
										<div className="badge badge-shadow w-80">
											<div className="progress bg-light"></div>
										</div>
									}
									{ showProductAuthor &&
										<div className="badge badge-shadow w-50 d-block mb-2">
											<div className="progress bg-light"></div>
										</div>
									}
									{ showProductPrice &&
										<div className="badge badge-shadow w-50">
											<div className="progress bg-light"></div>
										</div>
									}
									{ ( showProductRating && design === 'style-v5' ) &&
										<div className="badge badge-shadow w-50 d-block mb-2">
											<div className="progress bg-light"></div>
										</div>
									}
									{ ( showTimer && design !== 'style-v4' && design !== 'style-v6' ) &&
										<Fragment>
											{ showTimerTitle &&
												<div className="badge badge-shadow w-60 d-block">
													<div className="progress bg-light"></div>
												</div>
											}
											<div className="d-flex align-items-stretch justify-content-between mt-4">
												<div className="py-2d75 bg-light rounded-md" style={ { width:'65px', height:'51px' } }></div>
												{ design !== 'style-v3' &&
													<div className="border-left pr-3 pr-md-0">&nbsp;</div>
												}
												<div className="py-2d75 bg-light rounded-md" style={ { width:'65px', height:'51px' } }></div>
												{ design !== 'style-v3' &&
													<div className="border-left pr-3 pr-md-0">&nbsp;</div>
												}
												<div className="py-2d75 bg-light rounded-md" style={ { width:'65px', height:'51px' } }></div>
												{ design !== 'style-v3' &&
													<div className="border-left pr-3 pr-md-0">&nbsp;</div>
												}
												<div className="py-2d75 bg-light rounded-md" style={ { width:'65px', height:'51px' } }></div>
											</div>
										</Fragment>
									}
									{ showProgressBar &&
										<Fragment>
											<div className="d-flex justify-content-between mb-2d75 mt-5">
												<span className="badge badge-shadow rounded-pill bg-light d-inline-block" style={ { width:'130px', height:'20px' } }></span>
												{ design !== 'style-v4' &&
													<span className="badge badge-shadow rounded-pill bg-light d-inline-block" style={ { width:'130px', height:'20px' } }></span>
												}
											</div>
											<div className="progress bg-light">
												<div className="progress-bar w-60" role="progressbar" style={ { backgroundColor: '#ececec' } }></div>
											</div>
										</Fragment>
									}
								</div>
							</div>
						</div>
					)
				} ) }
			</div>
		)

		return output
	}
}

export default ProductsDealsCarouselPlaceholder